import { SGB_ORDER_DETAILS, SGB_ORDER_ERROR, SGB_ORDER_HIDE_ERROR, SGB_ORDER_START_LOADER, SGB_ORDER_STOP_LOADER, } from "../interface/iSGBOrderDetails";
const initState = {
    data: [],
    loader: false,
    errorData: {
        erorr: null,
        isOpen: false,
    },
};
const sgbOrderDetailsReducer = (state = initState, action) => {
    switch (action.type) {
        case SGB_ORDER_DETAILS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case SGB_ORDER_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case SGB_ORDER_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case SGB_ORDER_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case SGB_ORDER_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default sgbOrderDetailsReducer;
